import React, {  useState } from "react";

import PropTypes from "prop-types";
import {
  Button,

  Col,

  Form,
  FormFeedback,
  Input,
  Label,
  Row,
  Alert
} from "reactstrap";



// Redux
import { connect} from "react-redux";
import { withRouter, useHistory } from "react-router-dom";

import { contactsCreate } from "../../../store/contacts/actions";


const ContactoEmpresa = (props) => {
    const history = useHistory();
  
   

   

   
  
 

    const optionGroupTipoIdentificacion = [
        {
    
          options: [
            { label: "CEDULA", value: "CEDULA" },
            { label: "PASAPORTE", value: "PASAPORTE" },
            { label: "CEDULA DE EXTRANJERIA", value: "CEDULA_EXTRANJERIA" },
            { label: "NIT", value: "NIT" },
            { label: "OTRO", value: "OTRO" },
            
          ],
        },
    
      ];

    


    



    const [formData, setFormData] = useState({
        username:props.datos.username? props.datos.username:"",
       
        documentNumber:props.datos.documentNumber? props.datos.documentNumber:"",
        birthdate:"2000-01-01",
        city: props.datos.city? props.datos.city:"",
        razon_social:props.datos.razon_social? props.datos.razon_social:"",
        phone:props.datos.phone? props.datos.phone:"",
        address:props.datos.address? props.datos.address:"",
        barrio_localidad:props.datos.barrio_localidad? props.datos.barrio_localidad:"",
        cargo:props.datos.cargo? props.datos.cargo:"",
        persona_contacto:props.datos.persona_contacto? props.datos.persona_contacto:"",
        first_name:props.datos.first_name? props.datos.first_name:"",
        last_name:props.datos.last_name? props.datos.last_name:"",
        contactType: props.datos.contactType? props.datos.contactType: "",
        tipo_cliente: props.datos.tipo_cliente? props.datos.tipo_cliente : ""
        
  
  
   });
  
   const {  username , razon_social, documentNumber, birthdate, city, phone,address,barrio_localidad,persona_contacto,
    cargo,first_name,last_name,contactType,tipo_cliente, documentType} =
     formData;
  
  
   const onChange = (e) => {

    const uppercaseValue = e.target.value.toUpperCase()
     setFormData({ ...formData, [e.target.name]: uppercaseValue });
   };
  
   const onSubmit = (e) => {
     e.preventDefault();
     
     props.contactsCreate({
      razon_social,
      username,
      
      documentType,
      documentNumber,
      birthdate,
      city,
      phone,
      address,
      barrio_localidad,
      tipo_cliente,
      cargo,
      persona_contacto,
      first_name,
      last_name,
      contactType

     
     });
     props.hijoAPadre({ 
      razon_social,
      username,
      
      documentType,
      documentNumber,
      birthdate,
      city,
      phone,
      address,
      barrio_localidad,
      tipo_cliente,
      cargo,
      persona_contacto,
      first_name,
      last_name,
      contactType
    })
     
    };
    const goback = () => {
        history.goBack()
      };
  
    return ( 
        <React.Fragment>
            
                        <Form 
                                onSubmit={onSubmit}
                                >


                 

                                    {/* Razon Social y telefono */}
                <Row>
                    <Col lg={6} className="mb-3">                    
                      <Label
                        for="razon_social"
                        className="form-label"
                      >
                        Razon Social
                      </Label>
                      <Input
                        id="razon_social"
                        name="razon_social"
                        type="text"
                        onChange={onChange}
                        defaultValue={props.datos.razon_social}
                        value={razon_social}
                        valid={props.error.razon_social
                          ? true
                          : props.contactsCreated && false
                        }
                        invalid={
                          props.error
                            ? props.error.razon_social
                              ? true
                              : false
                            : false
                        }
                      />



                      <FormFeedback>{props.error.razon_social}</FormFeedback>
                
                    </Col>           


                    

                     <Col lg={6} className="mb-3">                    
                      <Label
                        for="phone"
                        className="form-label"
                      >
                        Telefono y/o celular
                      </Label>
                      <Input
                        id="phone"
                        name="phone"
                        type="text"
                        onChange={onChange}
                        defaultValue={props.datos.phone}
                        
                        valid={props.error.phone
                          ? true
                          : props.contactsCreated && false
                        }
                        invalid={
                          props.error
                            ? props.error.phone
                              ? true
                              : false
                            : false
                        }
                      />



                      <FormFeedback>{props.error.phone}</FormFeedback>
                
                    </Col>    
                   
                    
                  </Row>

   
                        {/* Nombres y Apellidos */}
                        <Row>
                  <Col lg={6} className="mb-3">                    
                    <Label
                      for="first_name"
                      className="form-label"
                    >
                      Nombres
                    </Label>
                    <Input 
                      id="first_name"
                      name="first_name"
                      type="text"
                      onChange={onChange}
                      
                      defaultValue={props.datos.first_name}
                      value={first_name}
                      
                    />

                  </Col>                  
                  <Col lg={6}  className="mb-3">                    
                    <Label
                      for="apellido"
                      className="form-label"
                    >
                      Apellidos
                    </Label>
                    <Input
                      id="last_name"
                      name="last_name"
                      type="text"
                      onChange={onChange}
                      defaultValue={props.datos.last_name}  
                      value={last_name}
                                        
                      
                    />
                    <FormFeedback>{props.error.last_name}</FormFeedback>
                  
                  </Col>
                </Row>
                  
                                       {/* Persona contacto y Cargo */}
                                       <Row>
                    <Col lg={6} className="mb-3">                    
                      <Label
                        for="persona_contacto"
                        className="form-label"
                      >
                        Persona Contacto
                      </Label>
                      <Input
                        id="persona_contacto"
                        name="persona_contacto"
                        type="text"
                        onChange={onChange}
                        defaultValue={props.datos.persona_contacto} 
                        value={persona_contacto} 
                        valid={props.error.persona_contacto
                          ? true
                          : props.contactsCreated && false
                        }
                        invalid={
                          props.error
                            ? props.error.persona_contacto
                              ? true
                              : false
                            : false
                        }
                      />
                      <FormFeedback>{props.error.persona_contacto}</FormFeedback>
                
                    </Col>                  
                    <Col lg={6}  className="mb-3">                    
                      <Label
                        for="cargo"
                        className="form-label"
                      >
                        Cargo
                      </Label>
                      <Input
                        id="cargo"
                        name="cargo"
                        type="text"
                        onChange={onChange}
                        defaultValue={props.datos.cargo}  
                        value={cargo} 
                        valid={props.error.cargo
                          ? true
                          : props.contactsCreated && false
                        }
                        invalid={
                          props.error
                            ? props.error.cargo
                              ? true
                              : false
                            : false
                        }
                      />
                      <FormFeedback>{props.error.cargo}</FormFeedback>
                     
                    </Col>
                  </Row>

                        {/* tipo de Contacto y tipo de identificacion */}
                  <Row>
                  <Col lg={6} className="mb-3">
                      <Label
                        for="contactType"
                        className="form-label"
                      >
                      Tipo de Contacto
                      </Label>

                    <select
                            className="form-select"
                            id="contactType"
                            name="contactType"
                            defaultValue={props.datos.contactType}    
                            value={contactType}                      
                            onChange={onChange}
                            >
                              <option defaultValue ="">
                              Seleccione
                            </option>
                           <option value ="PERSONA NATURAL">
                              PERSONA NATURAL
                            </option>
                            <option value ="PERSONA JURIDICA">
                            PERSONA JURIDICA
                            </option>
                           
                            <option value ="OTRO">
                            OTRO
                            </option>
                    </select>
                            
                         
                  

                  {props.error && props.error.contactType ? (
                                      <Alert color = 'danger' className="mt-2">{props.error.contactType}</Alert>
                                      ):null}
                    </Col>

                    <Col lg={6} className="mb-3">
                      <Label
                        for="contactType"
                        className="form-label"
                      >
                      Tipo de identificación
                      </Label>
                    <select
                            className="form-select"
                            id="documentType"
                            name="documentType"
                            defaultValue={props.datos.documentType}  
                            value={documentType}   
                            onChange={onChange}
                             
                            
                          >
                             <option value="">Seleccione</option>

                                                                {Array.isArray(optionGroupTipoIdentificacion) ?
                                                                      optionGroupTipoIdentificacion[0].options.map((item) => (
                                                                        <option
                                                                          key={item.value}
                                                                          value={item.value}
                                                                        >
                                                                          {item.label}
                                                                        </option>
                                                                      )):[]}

                          </select>
                    </Col>     
                            
                </Row>

                        {/* Documento y CIudad */}
                <Row>
                    <Col lg={6} className="mb-3">
                      <Label
                        for="documento"
                        className="form-label"
                      >
                        Documento
                      </Label>
                      <Input
                        id="documentNumber"
                        name="documentNumber"
                        type="number"
                        onChange={onChange}
                        defaultValue={props.datos.documentNumber}  
                        value={documentNumber}   
                        valid={props.error.documentNumber
                          ? true
                          : props.contactsCreated && false
                        }
                        invalid={
                          props.error
                            ? props.error.documentNumber
                              ? true
                              : false
                            : false
                        }
                      />
                      <FormFeedback>{props.error.documentNumber}</FormFeedback>
                    </Col>

                    <Col lg={6} className="mb-3">
                      <Label
                        for="city"
                        className="form-label"
                      >
                        Ciudad
                      </Label>
                      <Input
                        id="city"
                        name="city"
                        type="text"
                        onChange={onChange}
                        defaultValue={props.datos.city}  
                        value={city}   
                        valid={props.error.city
                          ? true
                          : props.contactsCreated && false
                        }
                        invalid={
                          props.error
                            ? props.error.city
                              ? true
                              : false
                            : false
                        }
                      />
                      <FormFeedback>{props.error.city}</FormFeedback>
                    </Col>
                    </Row>


                     {/* Direaccion  y Barrio o Localidad */}
                <Row>
                    <Col lg={6} className="mb-3">
                      <Label
                        for="address"
                        className="form-label"
                      >
                        Direccion 
                      </Label>
                      <Input
                        id="address"
                        name="address"
                        type="text"
                        onChange={onChange}
                        defaultValue={props.datos.address}
                        value={address}     
                        valid={props.error.address
                          ? true
                          : props.contactsCreated && false
                        }
                        invalid={
                          props.error
                            ? props.error.address
                              ? true
                              : false
                            : false
                        }
                      />
                      <FormFeedback>{props.error.address}</FormFeedback>
                    </Col>

                    <Col lg={6} className="mb-3">
                      <Label
                        for="barrio_localidad"
                        className="form-label"
                      >
                        Barrio o Localidad
                      </Label>
                      <Input
                        id="barrio_localidad"
                        name="barrio_localidad"
                        type="text"
                        onChange={onChange}
                        
                        defaultValue={props.datos.barrio_localidad}  
                        value={barrio_localidad} 
                        valid={props.error.barrio_localidad
                          ? true
                          : props.contactsCreated && false
                        }
                        invalid={
                          props.error
                            ? props.error.barrio_localidad
                              ? true
                              : false
                            : false
                        }
                      />
                      <FormFeedback>{props.error.city}</FormFeedback>
                    </Col>
                    </Row>

                         {/* tipo de Clientey Correo*/}
                  <Row>
                  
                  <Col lg={6} className="mb-3">
                      <Label
                        for="tipo_cliente"
                        className="form-label"
                      >
                      Tipo de Contacto
                      </Label>

                    <select
                            className="form-select"
                            id="tipo_cliente"
                            name="tipo_cliente"
                            defaultValue={props.datos.tipo_cliente}       
                            value={tipo_cliente}                     
                            onChange={onChange}
                            >
                           
                           <option defaultValue ="Seleccione">
                              Seleccione
                            </option>
                            <option value ="CLIENTE ANTIGUO">
                            CLIENTE ANTIGUO
                            </option>
                            <option value ="CLIENTE NUEVO">
                              CLIENTE NUEVO
                            </option>
                            <option value ="PROVEEDOR">
                             PROVEEDOR
                            </option>
                    </select>
                  
                           {props.error && props.error.tipo_cliente ? (
                    <Alert color = 'danger' className="mt-2">{props.error.tipo_cliente}</Alert>
                    ):null}
                      
                    </Col>

                    <Col lg={6} className="mb-3">
                      <Label
                        for="username"
                        className="form-label"
                      >
                      Correo Electrónico
                      </Label>
                      <Input
                        id="username"
                        name="username"
                        type="text"
                        placeholder="example@xxxx.com"

                        onChange={onChange}
                        defaultValue={props.datos.username} 
                        value={username}   
                        valid={props.error.username
                          ? true
                          : props.contactsCreated && false
                        }
                        invalid={
                          props.error
                            ? props.error.username
                              ? true
                              : false
                            : false
                        }
                      />
                      <FormFeedback>{props.error.username}</FormFeedback>
                    </Col>  
                            
                </Row>


                <Row className="col-lg-12 justify-content-center">
                    <Col md={1} className= 'mx-1'>
                      <Button color="primary" type="submit">
                        Enviar
                      </Button>
                    </Col>
                    <Col md={1} className= 'mx-1'>
                    <button className="btn btn-secondary" 
                      type="button"
                                                            onClick={goback}
                                                        >
                                                            Volver
                                                        </button>
                    </Col>
                  </Row>
                                </Form>

        </React.Fragment>
     );
}
 
const mapStateToProps = (state) => {
    const { error, loading, contactsCreated } = state.Contacts;
    return { error, loading, contactsCreated};
  };
  
  ContactoEmpresa.propTypes = {
    error: PropTypes.any,
    loading: PropTypes.bool,
    contactsCreated: PropTypes.object,
  };
  export default withRouter(connect(mapStateToProps, { contactsCreate })(ContactoEmpresa));
  